import React from 'react';

const ChessBoard = ({ rows, columns, activePosition, typeCabinet }) => {
    const generateGridSquare = () => {
        const grid = [];
        for (let i = 0; i < rows; i++) {
            const row = [];
            for (let j = 0; j < columns; j++) {
                const isActive = i === activePosition.row - 1 && j === activePosition.column - 1;
                row.push(
                    <div key={`${i}-${j}`} className={`grid-cell ${isActive ? 'active' : ''}`}>{`${i + 1}-${
                        j + 1
                    }`}</div>
                );
            }
            grid.push(
                <div key={i} className="grid-row">
                    {row}
                </div>
            );
        }
        return grid.reverse();
    };

    const generateGridRound = () => {
        let row = [];
        for (let i = 0; i < rows; i++) {
            let column = [];
            for (let j = 0; j < columns; j++) {
                const isActive = i === activePosition.row - 1 && j === activePosition.column - 1;
                column.push(
                    <div key={`${i}-${j}`} className={`grid-cell ${isActive ? 'active' : ''}`}>
                        {`${j + 1}`}
                    </div>
                );
                if ((j + 1) % 5 === 0 || j === columns - 1) {
                    row.push(
                        <div key={j} className="grid-row">
                            {column}
                        </div>
                    );
                    column = [];
                }
            }
        }
        return row;
    };

    return (
        <div className="grid-container">
            <div className="grid">{typeCabinet === 'round' ? generateGridRound() : generateGridSquare()}</div>
        </div>
    );
};

export default ChessBoard;
